const set = require('regenerate')(0x1D2B, 0x1D78, 0x1DF8, 0x2E43);
set.addRange(0x400, 0x52F).addRange(0x1C80, 0x1C88).addRange(0x2DE0, 0x2DFF).addRange(0xA640, 0xA69F).addRange(0xFE2E, 0xFE2F);
module.exports = set;
